var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon",
      attrs: {
        width: "800px",
        height: "800px",
        viewBox: "0 0 1024 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M618.666667 192L362.666667 106.666667 106.666667 192v682.666667l256-85.333334 256 85.333334 256-85.333334V106.666667z",
          fill: "#FFECB3",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M362.666667 106.666667v682.666666l256 85.333334V192z",
          fill: "#FFD54F",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M917.333333 661.333333c0 141.376-114.624 256-256 256s-256-114.624-256-256 114.624-256 256-256 256 114.624 256 256",
          fill: "#00ACC1",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M853.333333 661.333333c0 106.048-85.952 192-192 192s-192-85.952-192-192 85.952-192 192-192 192 85.952 192 192",
          fill: "#EEEEEE",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M640 512h42.666667v149.333333h-42.666667z", fill: "" },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M646.954667 675.712l28.757333-28.757333 81.045333 81.045333-28.757333 28.757333z",
          fill: "",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M693.333333 661.333333a32 32 0 1 1-64.021333-0.021333A32 32 0 0 1 693.333333 661.333333",
          fill: "",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }